import { SimpleListItem } from '../shared/components/simple-list';

export function sortByKey(key: string) {
    return (a: any, b: any) => {
        if (typeof a[key] === 'string') {
            const keyA = a[key].toUpperCase(); // ignore upper and lowercase
            const keyB = b[key].toUpperCase(); // ignore upper and lowercase

            if (keyA < keyB) {
                return -1;
            }
            if (keyA > keyB) {
                return 1;
            }

            // keys must be equal
            return 0;
        } else if (typeof a[key] === 'number') {
            return a[key] - b[key];
        } else {
            return false;
        }
    };
}

export function sortListItemsByLabel() {
    return (a: SimpleListItem, b: SimpleListItem) => {
        const nameA = a.label
            ? a.label.toLocaleUpperCase()
            : a.secondaryLabel
            ? a.secondaryLabel.toLocaleUpperCase()
            : '';
        const nameB = b.label
            ? b.label.toLocaleUpperCase()
            : b.secondaryLabel
            ? b.secondaryLabel.toLocaleUpperCase()
            : '';
        if (nameA < nameB) {
            return -1;
        }

        if (nameA > nameB) {
            return 1;
        }

        // names must be equal
        return 0;
    };
}
